import { lazy } from 'react';
import { Route, Navigate, useLocation } from 'react-router-dom';
import { pageNames } from '@common/routes/pageNames';

const AccountCanceled = lazy(() => import('@admission/pages/AccountCanceled'));

//#region ACP
const ACPSignIn = lazy(() => import('@admission/pages/ACP/SignIn'));
const ACPSignUp = lazy(() => import('@admission/pages/ACP/SignUp'));

const ACPRecoveryPassword = lazy(() => import('@admission/pages/ACP/RecoveryPassword'));
const ACPResetPassword = lazy(() => import('@admission/pages/ACP/ResetPassword'));

const ACPValidateConflictingEmail = lazy(() => import('@admission/pages/ACP/ValidateConflictingEmail'));

const ACPPublicEmailConfirmation = lazy(() => import('@admission/pages/ACP/PublicEmailConfirmation'));

const ACPInvalidSignUpKBA = lazy(() => import('@admission/pages/ACP/Error/InvalidSignUpKBA'));
const ACPBlockedSignUpKBA = lazy(() => import('@admission/pages/ACP/Error/BlockedSignUpKBA'));
const ACPBlockedSignUpLGPD = lazy(() => import('@admission/pages/ACP/Error/BlockedSignUpLGPD'));
const ACPInvalidRecoveryPasswordKBA = lazy(() => import('@admission/pages/ACP/Error/InvalidRecoveryPasswordKBA'));
const ACPBlockedRecoveryPasswordKBA = lazy(() => import('@admission/pages/ACP/Error/BlockedRecoveryPasswordKBA'));
const ACPInvalidResetPasswordKBA = lazy(() => import('@admission/pages/ACP/Error/InvalidResetPasswordKBA'));
const ACPBlockedResetPasswordKBA = lazy(() => import('@admission/pages/ACP/Error/BlockedResetPasswordKBA'));

const ACPBlockedSignIn = lazy(() => import('@admission/pages/ACP/Error/BlockedSignIn'));

const ACPSignUpNCAD = lazy(() => import('@admission/pages/ACP/SignUpNCAD'));
const ACPSignUpNCADCompleted = lazy(() => import('@admission/pages/ACP/SignUpNCADCompleted'));

const ACPSignUpPartnerCompleted = lazy(() => import('@admission/pages/ACP/SignUpPartnerCompleted'));
const ACPTesteIframe = lazy(() => import('@admission/pages/ACP/TesteIframe'));
//#endregion ACP

export function Router() {
  const location = useLocation();

  return (
    <>
      <Route
        path={pageNames.home.path}
        element={
          <Navigate to={`${pageNames.signin.path}${location?.search}`} />
        }
      />

			{/* ACP START */}

      <Route path={pageNames.signin.path} element={<ACPSignIn />} />
      <Route path={pageNames.testeIframe.path} element={<ACPTesteIframe />} />

      <Route path={pageNames.signup.path} element={<ACPSignUp />} />

			<Route path={pageNames.signUpNCAD.path} element={<ACPSignUpNCAD />} />
      <Route path={pageNames.signupNCADCompleted.path} element={<ACPSignUpNCADCompleted />} />

			<Route path={pageNames.signUpPartnerCompleted.path} element={<ACPSignUpPartnerCompleted />} />

      <Route path={pageNames.signupACPErrorKBA.path} element={<ACPInvalidSignUpKBA />} />
      <Route path={pageNames.signupACPBlockedKBA.path} element={<ACPBlockedSignUpKBA />} />
      <Route path={pageNames.signupACPBlockedLGPD.path} element={<ACPBlockedSignUpLGPD />} />

      <Route path={pageNames.recoveryPasswordACPInvalidKBA.path} element={<ACPInvalidRecoveryPasswordKBA />} />
      <Route path={pageNames.recoveryPasswordACPBlockedKBA.path} element={<ACPBlockedRecoveryPasswordKBA />} />

			<Route path={pageNames.resetPasswordACPInvalidKBA.path} element={<ACPInvalidResetPasswordKBA />} />
      <Route path={pageNames.resetPasswordACPBlockedKBA.path} element={<ACPBlockedResetPasswordKBA />} />

      <Route path={pageNames.signinACPFailedDocument.path} element={<ACPBlockedSignIn />} />

      <Route
        path={pageNames.recoveryPassword.path}
        element={<ACPRecoveryPassword />}
      />

      <Route
        path={pageNames.redefinePassword.path}
        element={<ACPResetPassword />}
      />

			<Route path={pageNames.validateConflictingEmailACP.path} element={<ACPValidateConflictingEmail />} />
			
			<Route path={pageNames.publicEmailConfirmation.path} element={<ACPPublicEmailConfirmation />} />
			{/* ACP END */}

      <Route
        path={pageNames.accountCanceled.path}
        element={<AccountCanceled />}
      ></Route>
    </> 
  );
}
